<template>
  <div>
    <nav>
      <div>
        <div class="nav-logo">
          <img src="https://zhimaicoud.com/upload/common/default/97012fc9129c7a121f88a5cf32eaac551765432237%5E%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250526105222_162.png" alt="至码云" />
        </div>
        <ul>
          <li @click="gomarket">首页</li>
          <li @click="goConsole">控制台</li>
        </ul>
      </div>
      <div class="nav-btn">
        <template v-if="!isLoggedIn">
          <div @click="goRegister">注册</div>
          <div @click="goLogin">登录</div>
        </template>
        <template v-else>
          <div class="user-info-nav">
            <span class="user-name">{{ userInfo.account }}</span>
            <span class="user-id">ID: {{ userInfo.id }}</span>
          </div>
        </template>
      </div>
    </nav>
    <main v-if="$route.name === 'market'">
      <div class="layout">
        <div>
          <span>分类:</span>
          <ul>
            <li
              @click="chooseClassify(item.name)"
              v-for="item in classify"
              :key="item.value"
              :class="{ check: checked == item.name }"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div>
          <span>平台:</span>
          <ul>
            <li
              @click="choosePlatform(item.name)"
              v-for="item in platform"
              :key="item.value"
              :class="{ check: checked == item.name }"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
      <div class="tips">
        <ul>
          <li>最新</li>
          <li>热度</li>
          <li>下载</li>
        </ul>
        <el-input placeholder="30个应用"></el-input>
      </div>
      <div class="application">
        <div
        @click="godetails"
          class="application-item"
          v-for="item in ProductList"
          :key="item.id"
        >
          <img :src="item.image" alt="" />
          <div>
            <div class="application-content">
              <span>应用</span> {{ item.title }}
              <div class="application-foot">
                <div class="browse">
                  <img src="../../assets/look.png" alt="" />
                  16802
                </div>
                <div class="download">
                  <img src="../../assets/download.png" alt="" />
                  631
                </div>
                <div class="price">￥{{ item.billing_price }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: "全部",
      classify: [
        { name: "全部", value: "all" },
        { name: "游戏", value: "game" },
        { name: "工具", value: "tool" },
        { name: "小程序", value: "mini" },
      ],
      platform: [
        { name: "全部", value: "all" },
        { name: "微信公众号", value: "android" },
        { name: "iOS", value: "ios" },
        { name: "H5", value: "h5" },
        { name: "网页应用", value: "web" },
      ],
      ProductList: {},
      isLoggedIn: false,
      userInfo: {}
    };
  },
  methods: {
    chooseClassify(name) {
      this.checked = name;
    },
    choosePlatform(name) {
      this.checked = name;
    },
    async getProductList() {
      const res = await this.$api.market.getProductList();
      if (res.code == 200) {
        this.ProductList = res.data;
      }
    },
    
    goApps(){
      this.$router.push('/apps')
    },
    goorder(){
      this.$router.push('/order')
    }
  ,
  godetails(){//详情
    this.$router.push('/market/details')
  },
  gomarket(){
      if(this.$route.name !== 'market')
      this.$router.push('/market')
    },
    goConsole() {
      this.$router.push('/index')
    },
    goRegister() {
      this.$router.push('/register')
    },
    goLogin() {
      this.$router.push('/login')
    },
    async checkLoginStatus() {
      try {
        const res = await this.$api.getUserInfo.get();
        if (res.code === 200 && res.data) {
          this.isLoggedIn = true;
          this.userInfo = res.data;
        } else {
          this.isLoggedIn = false;
        }
      } catch (error) {
        this.isLoggedIn = false;
      }
    }
  },
  created() {
    this.getProductList();
    this.checkLoginStatus();
  },
};
</script>

<style lang ="scss" scoped>
nav {
  height: 72px;
  width: 100%;
  padding: 0 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 249, 252, 0.95) 100%);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(94, 96, 206, 0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 4px 30px rgba(94, 96, 206, 0.06);
  
  .nav-logo {
    width: 140px;
    height: 50px;
    display: flex;
    align-items: center;
    margin-right: 30px;
    
    img {
      width: 100%;
      height: auto;
      object-fit: contain;
      filter: drop-shadow(0 2px 4px rgba(94, 96, 206, 0.1));
    }
  }
  
  > div:first-child {
    display: flex;
    align-items: center;
  }
  
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 600px;
    padding: 0;
    margin: 0;
    
    li {
      list-style: none;
      font-size: 15px;
      font-weight: 600;
      color: #4a4a68;
      padding: 12px 20px;
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      letter-spacing: 0.3px;
      
      &::after {
        content: '';
        position: absolute;
        bottom: 6px;
        left: 50%;
        transform: translateX(-50%) scaleX(0);
        width: 20px;
        height: 3px;
        background: linear-gradient(90deg, #5e60ce, #7c7ff6);
        border-radius: 2px;
        transition: transform 0.35s ease;
      }
      
      &:hover {
        color: #5e60ce;
        background: linear-gradient(135deg, rgba(94, 96, 206, 0.08), rgba(124, 127, 246, 0.05));
        transform: translateY(-2px);
        
        &::after {
          transform: translateX(-50%) scaleX(1);
        }
      }
    }
  }
  
  .nav-btn {
    display: flex;
    align-items: center;
    gap: 12px;

    .user-info-nav {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 10px 20px;
      background: linear-gradient(135deg, #5e60ce 0%, #7c7ff6 100%);
      border-radius: 12px;
      border: none;
      box-shadow: 0 4px 15px rgba(94, 96, 206, 0.3);
      
      .user-name {
        font-size: 15px;
        font-weight: 600;
        color: #ffffff;
        letter-spacing: 0.3px;
      }
      
      .user-id {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.85);
        letter-spacing: 0.3px;
      }
    }

    div {
      padding: 10px 24px;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
      letter-spacing: 0.3px;
      
      &:first-child {
        background: transparent;
        color: #5e60ce;
        border: 2px solid rgba(94, 96, 206, 0.2);
        
        &:hover {
          background: rgba(94, 96, 206, 0.05);
          border-color: #5e60ce;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(94, 96, 206, 0.15);
        }
      }
      
      &:last-child {
        background: linear-gradient(135deg, #5e60ce 0%, #7c7ff6 50%, #8b8fff 100%);
        color: #ffffff;
        border: none;
        box-shadow: 0 4px 15px rgba(94, 96, 206, 0.3);
        
        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(94, 96, 206, 0.4);
        }
      }
    }
  }
}
main {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #f8f9fc 0%, #f2f3f5 100%);
  overflow: hidden;
  padding-bottom: 40px;
  
  .layout {
    width: 1300px;
    height: auto;
    padding: 32px 28px;
    background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
    margin: 0 auto;
    margin-top: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: 20px;
    border: 1px solid rgba(94, 96, 206, 0.08);
    box-shadow: 
      0 8px 32px rgba(94, 96, 206, 0.08),
      0 2px 8px rgba(0, 0, 0, 0.04);
    
    div {
      flex: 1;
      display: flex;
      align-items: center;
    }
    
    span {
      margin-right: 24px;
      padding: 8px 0;
      font-size: 15px;
      font-weight: 600;
      color: #1a1a2e;
      letter-spacing: 0.3px;
    }
    
    ul {
      display: flex;
      gap: 8px;
      
      li {
        list-style-type: none;
        padding: 8px 20px;
        font-size: 15px;
        font-weight: 500;
        color: #4a4a68;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;
        letter-spacing: 0.3px;
        
        &:hover {
          background: linear-gradient(135deg, rgba(94, 96, 206, 0.08), rgba(124, 127, 246, 0.05));
          color: #5e60ce;
        }
      }
      
      .check {
        color: #ffffff;
        background: linear-gradient(135deg, #5e60ce, #7c7ff6);
        font-weight: 600;
        box-shadow: 0 4px 12px rgba(94, 96, 206, 0.25);
      }
    }
  }
  
  .tips {
    width: 1300px;
    height: auto;
    margin: 0 auto;
    padding: 30px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    ul {
      display: flex;
      gap: 24px;
      padding: 0;
      
      li {
        list-style-type: none;
        font-size: 15px;
        font-weight: 600;
        color: #8a8aa3;
        padding: 10px 20px;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;
        letter-spacing: 0.3px;
        
        &:hover {
          color: #5e60ce;
          background: rgba(94, 96, 206, 0.05);
        }
      }
    }
    
    .el-input {
      width: 260px;
      
      ::v-deep .el-input__inner {
        height: 44px;
        border-radius: 12px;
        border: 2px solid #e8eaf2;
        font-size: 15px;
        transition: all 0.3s ease;
        
        &:hover {
          border-color: #c5c8d6;
        }
        
        &:focus {
          border-color: #5e60ce;
          box-shadow: 0 0 0 3px rgba(94, 96, 206, 0.1);
        }
      }
    }
  }
  .application {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    justify-content: space-between;
    width: 1300px;
    margin: 0 auto;
    padding: 20px;
    gap: 20px;
    
    .application-item {
      width: 239px;
      height: 360px;
      background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
      padding: 0;
      box-sizing: border-box;
      margin-bottom: 10px;
      border-radius: 20px;
      border: 1px solid rgba(94, 96, 206, 0.08);
      box-shadow: 
        0 8px 24px rgba(94, 96, 206, 0.08),
        0 2px 8px rgba(0, 0, 0, 0.04);
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      overflow: hidden;
      cursor: pointer;

      &:hover {
        transform: translateY(-8px);
        box-shadow: 
          0 16px 40px rgba(94, 96, 206, 0.15),
          0 8px 20px rgba(94, 96, 206, 0.1);
        border-color: rgba(94, 96, 206, 0.15);
      }

      img {
        width: 100%;
        height: 240px;
        object-fit: cover;
        transition: transform 0.4s ease;
      }

      &:hover img {
        transform: scale(1.05);
      }

      .application-content {
        width: 100%;
        height: 80px;
        padding: 16px 14px;
        font-size: 15px;
        font-weight: 600;
        color: #1a1a2e;
        letter-spacing: 0.3px;
        
        span {
          display: inline-block;
          width: auto;
          height: 22px;
          line-height: 22px;
          padding: 0 10px;
          background: linear-gradient(135deg, #5e60ce, #7c7ff6);
          font-size: 11px;
          font-weight: 600;
          color: #ffffff;
          border-radius: 6px;
          box-sizing: border-box;
          letter-spacing: 0.5px;
        }
        
        .application-foot {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 13px;
          padding-top: 14px;
          margin-top: 8px;
          
          img {
            width: 16px;
            height: 16px;
            margin-right: 6px;
          }
          
          .browse,
          .download {
            display: flex;
            align-items: center;
            color: #8a8aa3;
            font-weight: 500;
          }
          
          .price {
            color: #ff6b6b;
            font-weight: 700;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>